import React, { useContext } from "react";
import { FiMessageSquare } from "react-icons/fi"; // Import chat icon
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { AuthContext } from "../../../../Auth/AuthContext";
import classNames from "classnames"; // Import classNames utility for conditional classes
import { styleTotalCoins } from "../../../../Components/Common/CommonFunction";
import dollar from "../../../../../src/assets/images/Icons/dollar.png";

const TotalPoints = () => {
  const navigate = useNavigate(); // Get navigate function from useNavigate
  const { totalPoints } = useContext(AuthContext);

  return (
    <li className="nav-item">
      <div className="d-flex  align-items-center">
        <img width="22px" height="22px" className="me-1" src={dollar} alt="" />
        <h6 className="font-secondary mb-0 ">{styleTotalCoins(totalPoints)}</h6>
      </div>
    </li>
  );
};

export default TotalPoints;
